export default "__VITE_ASSET__GUe_C3YV__"